import * as React from "react";

import { cn } from "@/utils/cn";

function Input({
  className,
  type,
  // The mini app never wants the browser's saved-value dropdown over its fields
  // (phone numbers, 2FA passwords, payout addresses). Pass an explicit
  // autoComplete at the call site to opt a field back in.
  autoComplete = "off",
  ...props
}: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      autoComplete={autoComplete}
      data-slot="input"
      className={cn(
        "h-(--control-height) w-full min-w-0 rounded-lg border-2 border-transparent bg-tg-section-bg px-4 text-base text-foreground transition-colors outline-none placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
